enum InterestMethodEnum {
    InterestMethod360 = '360_DAY',
    InterestMethod365 = '365_DAY',
}

export default InterestMethodEnum;
